import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { IContentHeader } from "../../../../layout/components/content-header/content-header.component";
import { UtilsService } from "../../../../auth/service/utils.service";
import moment from "moment";
import { EmployeeCostsService } from "../../employee-costs.service";
import { AuthenticationService, UserService } from "../../../../auth/service";
import { Router } from "@angular/router";
import { CollaboratorsService } from "../../../collaborators/collaborators.service";

@Component({
  selector: "app-update-employee-costs",
  templateUrl: "./update-employee-costs.component.html"
})
export class UpdateEmployeeCostsComponent implements OnInit {
  public contentHeader: IContentHeader;
  public fileName: string = null;
  public fileContent: any[] = [];
  public costsList: any = [];
  public month: number = moment().month();
  public months: number[] = Array.from({ length: 12 }, (_, i) => i + 1);
  public year: number = moment().year();
  public years: number[] = Array.from({ length: 5 }, (_, i) => i + 2024);
  public last_update: string;
  private savedCostsList: any = [];
  public filteredSavedCostsList: any = [];
  public filteredSavedCostsTotals: any = {};
  public filterMonth: number = moment().month();
  public filterYear: number = moment().year();
  public filterSearch: string = "";
  public findErrors: string[] = [];
  public updateErrors: string[] = [];
  private employees: any = [];
  public openedErrorTab: string = "";

  constructor(
    public _utilService: UtilsService,
    private _changeDetectorRef: ChangeDetectorRef,
    private _userService: UserService,
    private _employeeCostsService: EmployeeCostsService,
    private _authenticationService: AuthenticationService,
    private _router: Router,
    private collaboratorService: CollaboratorsService
  ) {
    this.contentHeader = {
      headerTitle: "EMPLOYEE_MONTHLY_COSTS",
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/"
          },
          {
            name: "MENU.MANAGE",
            isLink: true,
            link: "/dashboard/platform-management"
          },
          {
            name: "EMPLOYEE_MONTHLY_COSTS",
            isLink: false
          }
        ]
      }
    };
  }

  async ngOnInit() {
    if (!this._authenticationService.hasCapability("update_employee_monthly_costs")) {
      return this._router.navigateByUrl("/dashboard/platform-management");
    }

    if (this.filterMonth === -1) {
      this.filterMonth = 12;
      this.filterYear -= 1;
    }

    this.employees = await this._userService.getList("employee,ex-employee", null, true, "complete_name,hash,badge_number").then(async (results: any) => {
      const collaborators: any = await this.collaboratorService.getCollaboratorList();
      return [...results, ...collaborators];
    });

    this._utilService.showLoading();
    this.last_update = this._utilService.formatDate(this._utilService.themeConfiguration.last_costs_monthly_update, "DD/MM/YYYY HH:mm:ss");

    setTimeout(async () => {
      await this.filterSavedCosts();
    }, 100);
  }

  async handlerChangeFileInput($event: any) {
    this._utilService.showLoading();
    this.fileName = $event.target.files[0].name;
    if ($event.target.files && $event.target.files[0]) {
      this._utilService.parseXLSX(
        $event.target.files[0],
        [
          "A",
          "B",
          "C",
          "complete_name",
          "badge_number",
          "F",
          "ordinary_salary",
          "reward",
          "contributions",
          "ticket_value",
          "health_care",
          "transfers",
          "refunds",
          "documented_costs",
          "extra_contributions",
          "extra_salary",
          "tfr_slice",
          "inail",
          "total_cost",
          "net_salary"
        ],
        { raw: true, defval: 0, header: ["A", "B", "C", "D", "E", "F", "G", "H", "I", "J", "K", "L", "M", "N", "O", "P", "Q", "R", "S", "T", "U"] },
        async (data: any) => {
          const errorMessage: string = await this._utilService.translate("EMPLOYEE_NOT_FOUND");
          const fileContent = data
            .slice(7)
            .map((item: any) => {
              for (const key of Object.keys(item)) {
                if (key.length < 2) {
                  delete item[key];
                } else if (key !== "complete_name" && key !== "badge_number" && !!item[key]) {
                  if (!isNaN(Number(item[key]))) {
                    item[key] = Number(item[key].toFixed(2));
                  } else {
                    item[key] = parseInt(item[key]) || 0;
                  }
                }
              }

              item.total_cost -= item.health_care;

              const searchEmployee: any = this.employees.find((employee: any) => Number(employee.badge_number) === item.badge_number);

              if (!searchEmployee) {
                this.findErrors.push(`${item.complete_name} ${errorMessage}`);
                return null;
              }

              return item;
            })
            .filter((item: any) => item);

          this.fileContent = [];

          let badges = fileContent.map((item: any) => item.badge_number);
          badges = new Set(badges);

          for (const number of badges) {
            const records = fileContent.filter((item: any) => Number(item.badge_number) === number);
            if (records.length === 1) {
              this.fileContent.push(records[0]);
            } else {
              let summedObject = {
                complete_name: records[0].complete_name,
                badge_number: records[0].badge_number
              };
              for (const key in records[0]) {
                if (!["complete_name", "badge_number"].includes(key)) {
                  summedObject[key] = records.map((item: any) => Number(item[key])).reduce((acc: number, curr: number) => acc + curr, 0);
                }
              }
              this.fileContent.push(summedObject);
            }
          }

          this._utilService.hideLoading();
          return true;
        },
        "Consuntivo_cc_qual"
      );
    }
  }

  async processExcelFile() {
    this._utilService.showLoading();

    return this._employeeCostsService
      .updateMonthlyCosts({
        costs: this.fileContent,
        month: Number(this.month),
        year: Number(this.year)
      })
      .then(async (result: any) => {
        this.updateErrors = result.errors;
        this._utilService.hideLoading();
        await this.reset();
        this.filterMonth = moment().month() + 1;
        this.filterYear = moment().year();
        this.filterSearch = "";
        await this.filterSavedCosts();
        this.last_update = this._utilService.formatDate(moment(), "DD/MM/YYYY HH:mm:ss");
        this._utilService.themeConfiguration.last_costs_monthly_update = moment().toISOString();
        await this._utilService.showSWALSuccess({ text: "SUCCESS_USER_COSTS_MONTHLY_UPDATED" });
      })
      .catch(() => {
        this._utilService.hideLoading();
        this._utilService.showSWALError({ text: "ERROR_USER_COSTS_MONTHLY_UPDATED" });
      });
  }

  async reset() {
    this.costsList = [];
    this.fileName = null;
    this.fileContent = [];
    this.filterMonth = moment().month() + 1;
    this.filterYear = moment().year();
    this.month = moment().month();
    this.year = moment().year();
    this.findErrors = [];
    this.updateErrors = [];
    this.openedErrorTab = "";
    await this.filterSavedCosts();
  }

  getMonthName(month: number) {
    return moment()
      .month(month - 1)
      .format("MMMM");
  }

  async filterSavedCosts() {
    this._utilService.showLoading();
    await this._employeeCostsService
      .getMonthlyCosts(this.filterMonth, this.filterYear)
      .then((results: any) => {
        this.savedCostsList = results;
        this.searchSavedCosts();
        this._utilService.hideLoading();
      })
      .catch((e: any) => {
        console.error(e);
        this._utilService.hideLoading();
      });
  }

  searchSavedCosts() {
    let filtered: any[] = this.savedCostsList.map((item: any) => item);
    if (this.filterSearch.length > 0) {
      const keyword: string = this.filterSearch.toLowerCase();
      filtered = filtered.filter((item: any) => item.complete_name.toLowerCase().includes(keyword));
    }

    this.filteredSavedCostsTotals = {};

    const keys = ["reward", "contributions", "ticket_value", "health_care", "transfers", "refunds", "extra_contributions", "extra_salary", "tfr_slice", "inail", "total_cost", "net_salary", "ordinary_salary"];
    for (const row of filtered) {
      for (const key of keys) {
        if (!!this.filteredSavedCostsTotals[key]) {
          this.filteredSavedCostsTotals[key] += Number(row[key]);
        } else {
          this.filteredSavedCostsTotals[key] = Number(row[key]);
        }
      }
    }

    this.filteredSavedCostsList = filtered;
    this._changeDetectorRef.detectChanges();
  }
}
